var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NormalHeaderLayout',{attrs:{"header":""}},[_c('div',{staticClass:"single-widget"},[(_vm.loading || (_vm.resultExist && !_vm.widgetSpecReady))?_c('Spinner'):_vm._e(),(_vm.isWidgetReady)?[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",attrs:{"id":_vm.widgetSelector}})])]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }